import * as angular from 'angular';

import {
  Inject,
  OnInit,
  Component,
} from 'ng-metadata/core';

import searchCountriesHtml from './search-countries.html';

@Component({
  selector: 'gwSearchCountries',
  template: searchCountriesHtml,
})
export class SearchCountriesComponent {
  public GW = (<any>window).GW;
  public laroute = (<any>window).laroute;
  public countries = this.GW.countries;

  constructor(
    @Inject('$filter') private $filter,
  ) {}

  search(iso: string) {
    const country = this.countries.find((o) => {
      return o.value === iso;
    });

    window.location.assign(this.laroute.route('resources.embassies.country', {
      country: this.$filter('slugify')(country.label),
    }));
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/common/directory/countries/search-countries.component.ts